import Swiper from "swiper";

const SLIDER_SPEED = 300

let sliderText = new Swiper('.about-history__slider-text', {
    slidesPerView: 1,
    speed: SLIDER_SPEED,
    resistance: true,
    resistanceRatio: 0,
    allowTouchMove: false,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    breakpoints: {
        320: {
            autoHeight: true
        },
        768: {
            autoHeight: false
        }
    }
})
let sliderImg = new Swiper('.about-history__slider-img', {
    slidesPerView: 'auto',
    speed: SLIDER_SPEED,
    centeredSlides: true,
    resistance: true,
    resistanceRatio: 0,
    edgeSwipeThreshold: 0,
    // allowTouchMove: false,
    slideToClickedSlide: true,
})
let sliderDate = new Swiper('.about-history__slider-date', {
    slidesPerView: 'auto',
    speed: SLIDER_SPEED,
    centeredSlides: true,
    // slidesPerView: 1,
    resistance: true,
    resistanceRatio: 0,
    edgeSwipeThreshold: 0,
    slideToClickedSlide: true,
})

let isActiveDate = true

sliderImg.on('touchStart', ()=> { isActiveDate = false})
sliderDate.on('touchStart', ()=> { isActiveDate = true})

sliderDate.on('progress', (swiper, progress)=> {
    if (isActiveDate) {
        sliderImg.setProgress(progress, SLIDER_SPEED)
        sliderText.setProgress(progress, SLIDER_SPEED)
        if (window.matchMedia('(max-width: 768px)').matches) {
            sliderText.updateAutoHeight()
        }
    }
})
sliderImg.on('progress', (swiper, progress)=> {
    if (!isActiveDate) {
        sliderDate.setProgress(progress, SLIDER_SPEED)
        sliderText.setProgress(progress, SLIDER_SPEED)
        if (window.matchMedia('(max-width: 768px)').matches) {
            sliderText.updateAutoHeight(SLIDER_SPEED)
        }
    }
})

